import { Component, OnInit, ViewChild, AfterContentInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionService } from '../../../Services/transaction.service';
import { PaymentAgingParam } from "../../../Models/searchCustomer"
import { ContactConsigneeParams, UploadFileData } from '../../../Models/master';
import { OpsDetailParams, SpraRequestDetail, OpsProductDetail, Ops, SpraApprovalParams, SpraApprovalDetail, SpraApprovalRemarksParams, SpraValidation, SPRACompetitionDetailParams, SpraConsigneeData, SpraAmcvTotalValue, SpraRentalAmcvParams, SpraRentalEmiModel, SpraRentalPL, DiscountView, PriceRefCalculations, SpraRentalPLCalculation } from '../../../Models/ops';
import { ConsigneeProductSummary, ConsigneeSummary, OpsPartParams, OpsProduct, ProductSearchParam } from '../../../Models/product';
import { OpsPartSerachComponent } from '../../masters/ops-part-serach/ops-part-serach.component';
import { MatDialog, _closeDialogVia } from '@angular/material/dialog';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { OpsListComponent } from '../../masters/ops-list/ops-list.component';
import { OpsService } from '../../../Services/ops.service';
import { SpraApprovalComponent } from '../../masters/spra-approval/spra-approval.component';
import { SpraCompetitionDetailComponent } from '../../masters/spra-competition-detail/spra-competition-detail.component';
import { SpraNetSalePriceRealisedComponent } from '../../masters/spra-net-sale-price-realised/spra-net-sale-price-realised.component';
import { MasterService } from 'src/app/Services/master.service';
import { NotificationService } from 'src/app/Services/notification.service';
import { SpraPriceJustificationComponent } from '../../masters/spra-price-justification/spra-price-justification.component';
import { SpraApprovalRemarksComponent } from '../../masters/spra-approval-remarks/spra-approval-remarks.component';
import { CustomerAgeingComponent } from '../../masters/customer-ageing/customer-ageing.component';
import { MultipleFileUploadComponent } from '../../masters/multiple-file-upload/multiple-file-upload.component';
import { HttpEventType } from '@angular/common/http';
import { UploadFilesService } from 'src/app/Services/upload.service';
import { SpraAmcvRentalComponent } from '../../masters/spra-amcv-rental/spra-amcv-rental.component';
import { SpraRentalEmiComponent } from '../../masters/spra-rental-emi/spra-rental-emi.component';
import { SpraRentalPLComponent } from '../../masters/spra-rental-pl/spra-rental-pl.component';
import { SpraViewConsigneeComponent } from '../../masters/spra-view-consignee/spra-view-consignee.component';
import { SpraDiscountViewComponent } from '../../masters/spra-discount-view/spra-discount-view.component';
import { SpraConsigneeComponent } from '../../masters/spra-consignee/spra-consignee.component';
import { promise } from 'protractor';
import { PortalModule } from '@angular/cdk/portal';
import { Console } from 'console';


@Component({
  selector: 'app-spra-rental-request',
  templateUrl: './spra-rental-request.component.html',
  styleUrls: ['./spra-rental-request.component.css']
})
export class SpraRentalRequestComponent implements OnInit {

  paymentAgingParam: PaymentAgingParam;
  contactBillingParams: ContactConsigneeParams;
  contactConsigneeParams: ContactConsigneeParams;
  OpsPartParams: OpsPartParams;
  utility: Utility;
  SpraRequestDetail: SpraRequestDetail;
  param: any;
  LinkedOps: Ops;
  ValidTill: string;
  SPRAId: number = 0;
  OpportunityId: number = 0;
  Mode: string = "I";
  IsSalesAdmin: boolean = false;
  IsRequestReviewed:boolean=false;
  IsFromApprovedlist: boolean = false;
  RefSpraDetail: any;
  SPRAPriceRefId: any;
  spraApprovalDetail: SpraApprovalDetail;
  ExistingCsaRate: any[] = [];
  EmployeeId: number = 0;
  ProfitTag: boolean;
  IsCeha: boolean;
  IsRental: boolean = true;
  IsSpraHaveFinishGood: boolean = false;
  spraRentalEmiModel: SpraRentalEmiModel = new SpraRentalEmiModel();
  spraRentalPL: SpraRentalPL = new SpraRentalPL();
  InterestCostForPL: number[] = [];
  SpraRentalPLCalculation:SpraRentalPLCalculation;
  // @ViewChild(OpsDetailsComponent) opsDetailsComponent!: OpsDetailsComponent;  
  // @ViewChild("ContactConsignee") ContactConsigneeComponent!: ContactConsigneeComponent;
  // @ViewChild("ContactBilling") ContactBillingComponent!: ContactConsigneeComponent;
  @ViewChild(MultipleFileUploadComponent) MultipleFileUploadComponent !: MultipleFileUploadComponent;
  @ViewChild(CustomerAgeingComponent) CustomerAgeingComponent!: CustomerAgeingComponent;
  @ViewChild(OpsPartSerachComponent) opsPartSerachComponent!: OpsPartSerachComponent;
  @ViewChild(SpraApprovalComponent) SpraApprovalComponent!: SpraApprovalComponent;
  @ViewChild(SpraCompetitionDetailComponent) SpraCompetitionDetailComponent!: SpraCompetitionDetailComponent;
  @ViewChild(SpraNetSalePriceRealisedComponent) SpraNetSalePriceRealisedComponent!: SpraNetSalePriceRealisedComponent;
  @ViewChild(SpraAmcvRentalComponent) SpraAmcvRentalComponent!: SpraAmcvRentalComponent;
  @ViewChild(SpraPriceJustificationComponent) SpraPriceJustificationComponent!: SpraPriceJustificationComponent;
  @ViewChild(SpraApprovalRemarksComponent) SpraApprovalRemarksComponent!: SpraApprovalRemarksComponent;
  @ViewChild(SpraViewConsigneeComponent) SpraViewConsigneeComponent!: SpraViewConsigneeComponent;

  @ViewChild(SpraDiscountViewComponent) SpraDiscountViewComponent!: SpraDiscountViewComponent;
 
  //added by swati on 12/03/2021
  public SPRADetail: any;
  //end of addition by swati 
  public DisableSubmit:boolean = false;
  PageFor: any; //Added by Sagar Pandey on date 10-09-2025
  SpraValidationList: any; //Added by Sagar Pandey on date 10-09-2025
  AlreadyApproved: any; //Added by Sagar Pandey on date 10-09-2025

  constructor(private router: Router,
    private _TransactionService: TransactionService,
    private _CookieService: CookieService,
    private _OpsService: OpsService,
    private _MasterService: MasterService,
    private dialog: MatDialog,
    private _NotificationService: NotificationService,
    private uploadService: UploadFilesService
    ,private route: ActivatedRoute
  ) {
    this.utility = new Utility(this._CookieService);
    this.paymentAgingParam = new PaymentAgingParam();
    this.contactBillingParams = new ContactConsigneeParams();
    this.contactConsigneeParams = new ContactConsigneeParams();
    this.OpsPartParams = new OpsPartParams();
    this.SpraRequestDetail = new SpraRequestDetail();
    this.SpraRequestDetail.IsRental = true;
    this.LinkedOps = new Ops();
    this.SpraRentalPLCalculation = new SpraRentalPLCalculation();
    this.spraApprovalDetail = new SpraApprovalDetail();
    this.param = this.router.getCurrentNavigation()?.extras.state;
    this.EmployeeId = this.utility.user.employeeId;
    this.ProfitTag = false;
    this.IsCeha = false;
    this.ValidTill = "";
  }

  ngOnInit(): void {

    

  }


  ngAfterContentInit() {

    /*---just for testing */
    // this.paymentAgingParam.saleCode = "WM92463";
    // this.SpraRequestDetail.OfficeId = 14
    // this.SpraRequestDetail.RefId = 923343;
    // this.SpraRequestDetail.CompanyId = 80844716;
    // this.paymentAgingParam.CompanyId = this.SpraRequestDetail.CompanyId;
    // this.paymentAgingParam.officeId = this.SpraRequestDetail.OfficeId;    
    // this.SpraRequestDetail.SaleType = 'DD';
    // this.SPRAId = 75;
    // this.Mode = "U";

    // this.OpportunityId = 2375
    // this.ProfitTag = true;    
    //  this.IsSalesAdmin = true;
    
    // this.route.params.subscribe((params) =>{
    //   if(params.SPRAId!=undefined && params.SPRAId!=0){
    //     this.param = params;
        
    //   }
    // });

    if (this.param) {
      this.SpraRequestDetail.RefId = parseInt(this.param.RefId);
      this.SpraRequestDetail.CompanyId = parseInt(this.param.CompanyId);
      this.paymentAgingParam.CompanyId = parseInt(this.param.CompanyId);
      this.paymentAgingParam.saleCode = this.param.SaleCode;
      this.SpraRequestDetail.OfficeId = parseInt(this.param.OfficeId);
      this.paymentAgingParam.officeId = this.SpraRequestDetail.OfficeId;
      this.IsCeha = Boolean(this.param.IsCeha); //Added by rahul yadav in case of redirect to sas or sas
      if (this.param.SaleType != undefined && this.param.SaleType != "") {
        this.SpraRequestDetail.SaleType = this.param.SaleType;
      } else {
        this.SpraRequestDetail.SaleType = "DD";
      }
      if (this.param.IsSalesAdmin != undefined) {
        this.IsSalesAdmin = this.param.IsSalesAdmin;
      }
      if (this.param.SPRAId != undefined && this.param.SPRAId > 0) {
        this.SPRAId = parseInt(this.param.SPRAId);
        this.Mode = this.param.UpdateTag;
      }
      if (this.param.OpportunityId != undefined && this.param.OpportunityId > 0) {
        this.OpportunityId = this.param.OpportunityId;
      }
        //added by rahul yadav on 10/05/2022
        if(this.param.IsFromApprovedlist != undefined){
          this.IsFromApprovedlist = this.param.IsFromApprovedlist;
        }

    }

     //Added By Sagar Pandey on date 10-09-2025 
     if(this.param.PageFor != undefined){
      this.PageFor = this.param.PageFor;
    }


    setTimeout(() => {
      this.SpraApprovalComponent.CompanyId = this.SpraRequestDetail.CompanyId;
      //Iscompetetion change true to false by rahul yadav on 16/06/2021
      this.SpraCompetitionDetailComponent.IsCopetitionCsaRateRequired = false;
      this.SpraApprovalComponent.IsRental = this.IsRental;

      this.SpraCompetitionDetailComponent.IsRental = this.IsRental;
      this.CustomerAgeingComponent.BindAgeingDetail();
      this.opsPartSerachComponent.IsTaxApplicable = false;
      this.opsPartSerachComponent.IsRental = this.IsRental;
      this.opsPartSerachComponent.RefId = this.SpraRequestDetail.RefId;
      this.opsPartSerachComponent.BindProductSegment();
      this.opsPartSerachComponent.BindGrade(); //added by rahul yadav on 12/7/2021 to bind grade
      if (this.SpraNetSalePriceRealisedComponent != undefined) {
        this.SpraNetSalePriceRealisedComponent.SaleType = this.SpraRequestDetail.SaleType;
        this.SpraNetSalePriceRealisedComponent.DealerParam.OfficeId = this.SpraRequestDetail.OfficeId;
        if (this.Mode == 'I') {
          this.SpraNetSalePriceRealisedComponent.BindDealerList();
        }
        this.SpraNetSalePriceRealisedComponent.IsRental = this.IsRental;
      }
      if (this.SpraApprovalComponent != undefined) {
        this.SpraApprovalComponent.SaleType = this.SpraRequestDetail.SaleType;
        this.opsPartSerachComponent.SaleType = this.SpraRequestDetail.SaleType;
      }
      if (this.SpraApprovalRemarksComponent != undefined) {
        this.SpraApprovalRemarksComponent.IsSalesAdmin = this.IsSalesAdmin;
      }
      if (this.MultipleFileUploadComponent != undefined) {
        this.MultipleFileUploadComponent.SpraId = this.SPRAId;
      }



    }, 500);

    if (this.Mode == "U" && this.SPRAId != undefined && this.SPRAId > 0) {
      this.SpraRequestDetail.Id = this.SPRAId;

      this.GetSpraRequestData();

    }
    if (this.OpportunityId != undefined && this.OpportunityId > 0) {
      this.SpraRequestDetail.OpportunityId = this.OpportunityId;
      this.BindSpraEnquiryDetail();
    }


    this.GetExistingCsaRate();
  }


  // when model value change of OpsDetailComponent for (Dispatch Warehouse and Condignee State);
  changeOpsDetail(opsDetailParams: OpsDetailParams) {
    // this.opsPartSerachComponent.taxApiParam.StateFromId = opsDetailParams.DispatchWareHouseStateId;

  }

//Added By Sagar Pandey on Date 10-09-2025 to Check if the request exixts in validation list or not if yes it means it's not validated
  async GetSpraValidationList()
  {
  return this._TransactionService.GetSpraValidationList(this.EmployeeId,this.IsCeha).toPromise().then((d: any) => {
      this.SpraValidationList = d;
      if (this.SpraValidationList != null) {
        this.AlreadyApproved = this.SpraValidationList.filter((x: any) => x.id == this.SPRAId);
      }
  }, (error) => {                              //Error callback
    this.utility.Error(error);
  });
}


//Added By Sagar Pandey on Date 10-09-2025 to Check if the request exixts in validation list or not if yes it means it's not validated
async GetValidationListForAdminSales()
{
return this._TransactionService.GetValidationListForAdminSales(this.IsCeha).toPromise().then((d: any) => {
    this.SpraValidationList = d;
    if (this.SpraValidationList != null) {
      this.AlreadyApproved = this.SpraValidationList.filter((x: any) => x.id == this.SPRAId);
    }
}, (error) => {                              //Error callback
  this.utility.Error(error);
});
}


  openOpsList(): void {
    const dialogRef = this.dialog.open(OpsListComponent, {
      width: '80%',
      data: { refId: this.SpraRequestDetail.RefId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.FillSpraFromOps(result.data.recordId);
      }
    });
  }


  SaleTypeChange() {
    setTimeout(() => {
      this.ChangeOpsPartSerach(this.opsPartSerachComponent.ProductSearchParam);
      this.SpraApprovalComponent.SaleType = this.SpraRequestDetail.SaleType;
      this.SpraNetSalePriceRealisedComponent.SaleType = this.SpraRequestDetail.SaleType;
      this.SpraNetSalePriceRealisedComponent.ResetCommission();
      this.SpraAmcvRentalComponent.SaleType = this.SpraRequestDetail.SaleType;
    }, 0);
  }

  ChangeOpsPartSerach(ProductSearchParam: ProductSearchParam) {
    if (ProductSearchParam.ProdSegmentId > 0 && this.SpraRequestDetail.SaleType != "") {
      this.SpraApprovalComponent.BindWarrenty(ProductSearchParam.ProdSegmentId, this.SpraRequestDetail.SaleType, ProductSearchParam.WarrantyMonth);
      if (this.SpraAmcvRentalComponent != undefined) {
        this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail = [];
      }
      this.SpraApprovalComponent.SpraCsaRateArray = [];
      this.opsPartSerachComponent.TriggerProductModelChange();
      this.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
      this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
      this.opsPartSerachComponent.GetFinishedGoodsTotalPrice();

    }

  }

  ProductValueChanged(FinishGoodValue: number) {
    this.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
    this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
    this.SpraApprovalComponent.TotalFgValue = FinishGoodValue;
    this.SpraApprovalComponent.CalculateWarrentyCost();
    this.SetProductQtyToAmcv();



  }

  SetProductQtyToAmcv() {
    if (this.SpraAmcvRentalComponent != undefined) {
      Promise.all(this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail.map((am) => {
        am.Qty = this.opsPartSerachComponent.productArray.filter((pa) =>
          am.ProductList.indexOf(pa.SelectedProduct?.productId) >= 0
        ).map(mt => mt.Quantity).reduce((sum, current) => sum + current, 0);
        this.SpraAmcvRentalComponent.EmclChange(am);
      }));
    }
  }



  GetFGProduct(FGProdParam: Array<OpsProduct>) {
    this.SpraAmcvRentalComponent.AmcvFGProductParams = FGProdParam;
    //added by rahul yadav on 7/2/2021 to get sum of fg qty
    this.spraRentalPL.SumOfFGQty =  FGProdParam.map(mt => mt.Quantity).reduce((sum, current) => sum + current, 0);

  }

  GetAMCVTotalValues(spraAmcvTotalValue: SpraAmcvTotalValue) {
    //  alert("AMCV Total");
    this.opsPartSerachComponent.spraAmcvTotalValue = spraAmcvTotalValue;
    this.opsPartSerachComponent.CalcFGServTotAmount();
  }


  ChangeSpraApproval(spraApprovalParams: SpraApprovalParams) {
    if (this.SpraAmcvRentalComponent != undefined) {
      this.SpraAmcvRentalComponent.SpraApprovalParams = spraApprovalParams;
      this.SpraAmcvRentalComponent.CalculateA3CopyLoad();
    }
  }




  ChangeCounterList(CounterList: any[]) {
    // && this.Mode=="I"
      
    if(CounterList != null  && CounterList.length>0 && this.SpraRequestDetail.SaleType != "LL"){
      //Added by rahul yadav on 31/05/2021 for remove validation in case of no counter for the seleted model 
      this.SpraCompetitionDetailComponent.IsCopetitionCsaRateRequired = true;      
      this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail = new Array<SpraRentalAmcvParams>();
      this.SpraApprovalComponent.IsSpraHaveCopMfd = this.opsPartSerachComponent.GetSpraHaveCopMfdTag();
      let AmcvCounterWise: any[] = [];
      this._MasterService.GetCustomerAmcvCounterWise(this.SpraRequestDetail.CompanyId).toPromise().then((d) => {
        if (d) {
          AmcvCounterWise = AmcvCounterWise.concat(JSON.parse(d.toString()));

          Promise.all(CounterList.map(element => {
            if (this.SpraAmcvRentalComponent?.SpraRentalAmcvModel.CounterDetail.filter((sc) => { return sc.CounterId == element.counterId }).length <= 0) {
            let _SpraAmcvParams: SpraRentalAmcvParams = new SpraRentalAmcvParams();
            _SpraAmcvParams.TechnicalId = 0;
            _SpraAmcvParams.CounterId = element.counterId;
            _SpraAmcvParams.CounterDesc = element.counterDesc;
            _SpraAmcvParams.ProductList = element.productList;
            let ExistingCsaRate: any[] = this.ExistingCsaRate.filter(e => e.CounterId == element.counterId)
            if (ExistingCsaRate != undefined && ExistingCsaRate.length > 0) {
              _SpraAmcvParams.ExistingCSARate = ExistingCsaRate[0].Rate;
            }
            this.UpdateExistingAMCVInCounter(_SpraAmcvParams, AmcvCounterWise);
            
            this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail.push(_SpraAmcvParams);

            if (this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail.length == CounterList.length) {
              this.SetProductQtyToAmcv();
              this.SpraAmcvRentalComponent.ResetNotionalInput();
            }
          }

          }));


        }
      });





    }
    else{
      //Added by rahul yadav on 31/05/2021 for remove validation in case of no counter for the seleted model 
      this.SpraCompetitionDetailComponent.IsCopetitionCsaRateRequired = false;      
      this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail = new Array<SpraRentalAmcvParams>();
      this.SpraApprovalComponent.IsSpraHaveCopMfd = this.opsPartSerachComponent.GetSpraHaveCopMfdTag();

    }
  }

  UpdateExistingAMCVInCounter(spraRentalAmcvParams: SpraRentalAmcvParams, AmcvCounterWise: any[]) {
    spraRentalAmcvParams.ExistingAMCV = Math.ceil(AmcvCounterWise.filter(acw => {
      return acw.CounterId == spraRentalAmcvParams.CounterId
    })[0].AMCV);


  }

  FillSpraFromOps(OpsId: number) {
    this._OpsService.GetOpsDetailByOpsId(OpsId).subscribe((d: any) => {
      this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId = d.prodSegmentId;
      this.opsPartSerachComponent.ProductSearchParam.AdvanceGroupId = d.advanceGroupId;

      // this.ContactBillingComponent.consigneeId = d.billingId;
      // this.ContactBillingComponent.changeConsigneeAddress();

      // this.ContactConsigneeComponent.consigneeId = d.consigneeId;
      // this.ContactConsigneeComponent.changeConsigneeAddress()
      // this.opsDetailsComponent.OpsDetailParams.DispatchWareHouseId = d.opsOtherDetails.dispatchWareHouseId;
      // this.opsDetailsComponent.OpsDetailParams.ExecutiveId = d.opsOtherDetails.executiveId;
      // this.opsDetailsComponent.OpsDetailParams.PoRefNo = d.opsOtherDetails.poNumber;
      // this.opsDetailsComponent.OpsDetailParams.PoDate = d.opsOtherDetails.poDate;
      this.opsPartSerachComponent.productArray = new Array<OpsProduct>();
      this.opsPartSerachComponent.Mode = "U";
      Promise.all(d.opsProductDetails.map((element: any, index: number) => {

        let opsProduct: OpsProduct = new OpsProduct()
        this.opsPartSerachComponent.ProductSearchParam.ProductCode = element.productCode.replace(/\s+$/g, '');
        this.opsPartSerachComponent.ProductSearchParam.ProductId = element.productId;
        opsProduct.Price = element.unitPrice;
        opsProduct.Quantity = element.quantity;

        this.opsPartSerachComponent.productArray.push(opsProduct);
        this.opsPartSerachComponent.BindProductAutocomplete(opsProduct, index);
        if (index == 0) {
          this.opsPartSerachComponent.ProductSearchParam.WarrantyMonth = element.warrantyMonth;
          this.ChangeOpsPartSerach(this.opsPartSerachComponent.ProductSearchParam);
        }

      }));



      this.LinkedOps.OpsId = d.recordId
      this.LinkedOps.OpsNum = d.opsNum;
      this.LinkedOps.TempOpsNum = d.tempOpsNum;
      this.LinkedOps.OpsDate = d.opsDate;


      // this.OpsPaymentTermsComponent.PaymentTermParams.Amount = d.paymentTerms.amount;
      // this.OpsPaymentTermsComponent.PaymentTermParams.SlipNo = d.paymentTerms.slipNo;
      // this.OpsPaymentTermsComponent.PaymentTermParams.SlipDate = d.paymentTerms.slipDate;
      // this.OpsPaymentTermsComponent.PaymentTermParams.CreditDays = d.paymentTerms.creditDays;
      // this.OpsPaymentTermsComponent.PaymentTermParams.GeneralRemark = d.paymentTerms.generalRemark;
      // this.OpsPaymentTermsComponent.PaymentTermParams.BankGaurantee = d.paymentTerms.bankGaurantee;
      // this.OpsPaymentTermsComponent.PaymentTermParams.BGOnNationalBank = d.paymentTerms.bgOnNationalBank;

    });
  }


  async SpraSubmit() {
  
     //Added By Sagar Pandey On Date 10-09-2025 to prevent validation from duplicate screen if requet is already approved
      //"V" stands for spra Validation lIst SAS/SBS
    //"SAV" stands for SALES Admin ValidateList
     if(this.Mode =="U" && (this.PageFor == "V" || this.PageFor == "SAV"))
     {
      if(this.PageFor=="V")
      {
        await this.GetSpraValidationList()
      }
      else
      {
        await this.GetValidationListForAdminSales() //If Comming from Sales Admin Validate List
      }
       if(this.AlreadyApproved.length == 0)
       {
        let RedirectionPage: string = "spra-validationlist";
        if(!this.IsSalesAdmin && this.IsCeha){
          RedirectionPage = "spra-validationlist/1";
        }
        if (this.IsSalesAdmin && !this.IsCeha) { 
          RedirectionPage = "spra-adminsalesvalidate-list";
        }else if(this.IsSalesAdmin && this.IsCeha){
          RedirectionPage = "spra-adminsalesvalidate-list/1";
        }
         this.router.navigate([RedirectionPage], {
           state: {
             "Message": "Request Already Approved."
           }
         });
         return
       }
     }

    try{
      //condition added by rahul yadav on 10/05/2022 for spra reviewed request
      if(this.IsRequestReviewed){
        this.InitializeSpraRequestReviewModal();
      }
      else{
        this.DisableSubmit = true;
        this.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
        this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
        this.SpraApprovalComponent.ProdSegment = this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId;
        if (this.ValidateSpra()) {
          this.SpraRequestDetail.ProdSegmentId = this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId;
          this.SpraRequestDetail.AdvanceGroupId = parseInt(this.opsPartSerachComponent.AdvanceGroupId);
    
          this.SpraRequestDetail.EnteredBy = this.utility.user.employeeId;
          let _ProductDetails = new Array<OpsProductDetail>();
          Promise.all(this.opsPartSerachComponent.productArray.map(element => {
            if (element.SelectedProduct != undefined) {
              let _OpsProductDetail: OpsProductDetail = new OpsProductDetail();
              _OpsProductDetail.ProductId = element.SelectedProduct.productId;
              _OpsProductDetail.ProdMakeId = element.SelectedProduct.prodMakeId;
              _OpsProductDetail.ProdSegmentId = element.SelectedProduct.prodSegmentId;
              _OpsProductDetail.ProductGroupId = element.SelectedProduct.productGroupId;
              _OpsProductDetail.HsnCode = element.SelectedProduct.hsncode;
              _OpsProductDetail.GradeId = element.SelectedProduct.gradeId;
              _OpsProductDetail.UnitPrice = element.Price;
              _OpsProductDetail.Quantity = element.Quantity;          
              _OpsProductDetail.UnitSalePrice = element.UnitSalePrice;
              _OpsProductDetail.SaleAmount = element.SaleAmount;
              _OpsProductDetail.UnitWSCost = element.UnitWSCost;          
              _ProductDetails.push(_OpsProductDetail);
            }
          }));
          this.SpraRequestDetail.ProductDetails = JSON.stringify(_ProductDetails);
          if (this.ProfitTag){
            this.RecalculatePLDetail();
            let _PriceRefCalculations:PriceRefCalculations = new PriceRefCalculations();
            _PriceRefCalculations.Product = this.opsPartSerachComponent.ProductProfitablity;        
            _PriceRefCalculations.Product.NetSaleValueVGP = (((_PriceRefCalculations.Product.TotLoanAmount - _PriceRefCalculations.Product.TotDiscount) -_PriceRefCalculations.Product.TotCostAmount)/(_PriceRefCalculations.Product.TotLoanAmount - _PriceRefCalculations.Product.TotDiscount))*100;
            _PriceRefCalculations.EMI = this.spraRentalEmiModel;
            _PriceRefCalculations.PL = this.spraRentalPL;
            // if(this.SpraAmcvComponent != undefined){
            //   _PriceRefCalculations.AMCV = this.SpraAmcvComponent.AMCVProfitablity;
            // }
            this.SpraRequestDetail.PriceRefCalculations  = JSON.stringify(_PriceRefCalculations);
          }
    
    
          if (this.opsPartSerachComponent.spraConsigneeData.length > 0) {
            this.SpraRequestDetail.Consignee = JSON.stringify(this.opsPartSerachComponent.spraConsigneeData);
          }
          this.SpraRequestDetail.OpsId = this.LinkedOps.OpsId;
          this.SpraRequestDetail.OfficeId = this.utility.user.officeId;
    
          this.SpraRequestDetail.PriceApproval = JSON.stringify(this.SpraApprovalComponent.SpraApprovalParams);
    
          if (this.SpraNetSalePriceRealisedComponent != undefined) {
            this.SpraRequestDetail.NetSalePriceRealised = JSON.stringify(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams);
          }
          this.SpraRequestDetail.ComptDetail = JSON.stringify(this.SpraCompetitionDetailComponent.SPRACompetitionDetailArray.filter((t) => { return (t.CompName != undefined && t.CompName != "") }));
    
          if (this.SpraAmcvRentalComponent != undefined) {
            this.SpraRequestDetail.Amcv = JSON.stringify(this.SpraAmcvRentalComponent.SpraRentalAmcvModel)
          }
    
          if (this.Mode != "U") {
            if (this.SpraPriceJustificationComponent.SpraPriceJustificationParams.BoRemarks != undefined) {
              this.SpraRequestDetail.Remarks = this.SpraPriceJustificationComponent.SpraPriceJustificationParams.BoRemarks;
            }
          }
    
          if (this.SpraApprovalComponent != undefined && this.SpraApprovalComponent.SpraCsaRateArray.length > 0) {
            this.SpraRequestDetail.CsaRate = JSON.stringify(this.SpraApprovalComponent.SpraCsaRateArray);
          }
    
          //  first uploading document -->> after upload document -->> InsertUploadSpra() will call to create SPRA
          this.UploadDocuments();
        }
        else{
          this.DisableSubmit = false;  
        }
      }
    
  } catch(Error:any) {
    this.DisableSubmit  = false;
    console.log(Error.message);
  }finally{
    return true;
  }
  }



  InsertUploadSpra() {
    if (this.Mode == "U") {

      let _SpraValidation: SpraValidation = new SpraValidation();
      _SpraValidation.SpraRequest = this.SpraRequestDetail;

      // this._TransactionService.UpdateSPRAData(this.SpraRequestDetail).subscribe((d):any =>{
      //   if(d){   
      let Message: string;
      //  let Message:string = "SPRA ["+ d +"] updated"
      this.spraApprovalDetail.SpraRequestId = this.SPRAId;

      let spraApp: SpraApprovalRemarksParams;
      spraApp = this.SpraApprovalRemarksComponent.SpraApprovalRemarksParams.filter((item) => {
        return item.Tag == 0
      }
      )[0];

      if (spraApp.Remarks != undefined) {
        this.spraApprovalDetail.ValidateRemarks = spraApp.Remarks;
      }
      if (spraApp.AppStatus != undefined) {

        this.spraApprovalDetail.ApprovalStatus = spraApp.AppStatus;
      }
      this.spraApprovalDetail.ValidateBy = this.utility.user.employeeId;

      if (this.SpraApprovalRemarksComponent.IsSalesAdmin) {
        _SpraValidation.SpraRequest.ValidationRequired = JSON.stringify(this.SpraApprovalRemarksComponent.ValidationLevel
          .filter((vl) => { return vl.EmployeeId != undefined && vl.EmployeeId > 0 }));
      }

      _SpraValidation.SpraRequestApprovalValidation = this.spraApprovalDetail;

      let RedirectionPage: string = "spra-validationlist";
      if(!this.IsSalesAdmin && this.IsCeha){
        RedirectionPage = "spra-validationlist/1";
      }
      if (this.IsSalesAdmin && !this.IsCeha) { 
        RedirectionPage = "spra-adminsalesvalidate-list";
      }else if(this.IsSalesAdmin && this.IsCeha){
        RedirectionPage = "spra-adminsalesvalidate-list/1";
      }
       //added by rahul yadav for review on 06/5/2022
  
     if(this.spraApprovalDetail.ApprovalStatus=='V'){
      this._TransactionService.ReviewSPRA(_SpraValidation).subscribe((d): any => {
        if (d) {
          let Message: string = "SPRA request sent for Review successfully.";

          this.router.navigate([RedirectionPage], {
            state: {
              "Message": Message
            }
          });
        } else {
          this._NotificationService.showError();
          throw new Error('SPRA request not Reviewed.');
        }

      }, (error) => {
        this.utility.Error(error);
        this._NotificationService.showError();
      });
    }
    else{
      this._TransactionService.ValidationSPRA(_SpraValidation).subscribe((d): any => {
        if (d) {
          let Message: string = "SPRA validated successfully."

          this.router.navigate([RedirectionPage], {
            state: {
              "Message": Message
            }
          });
        } else {
          this._NotificationService.showError();
          throw new Error('SPRA request not validated.');
        }

      }, (error) => {
        this.utility.Error(error);
        this._NotificationService.showError();
      });
    }


    }
    //insertion
    else {
      this._TransactionService.InsertSpraRequest(this.SpraRequestDetail).subscribe((d): any => {
        if (d) {
          let Message: string = "SPRA Request [" + d + "] generated successfully."
          this.router.navigate(['search-customer/1'], {
            state: {
              "Message": Message
            }
          });
        } else {
          this._NotificationService.showError();
        }
      }, (error) => {
        this.utility.Error(error);
        this._NotificationService.showError();
        throw new Error('SPRA request not generated.');
      });
    }
  }


  ValidateSpra(): boolean {
    //for test  
  // console.log(this.opsPartSerachComponent.spraConsigneeData);
  // return false;

    if (!this.Validation()) {
      return false;
    } else if (!this.opsPartSerachComponent.Validation()) {
      return false;
    }
    // else if (this.IsSpraHaveFinishGood && (this.SpraRequestDetail.SaleType == 'DD' || this.SpraRequestDetail.SaleType == 'DL') 
    // && this.opsPartSerachComponent.spraConsigneeData.length <= 0)
    // {
    //   this._NotificationService.showError("Please enter Consignee Detail.","Consignee Detail");
    //   return false;
    // }
    else if (this.SpraApprovalComponent != undefined && !this.SpraApprovalComponent.Validation()) {
      return false;
    } else if (this.SpraAmcvRentalComponent != undefined && !this.SpraAmcvRentalComponent.Validation()) {
      return false;
    } else if (this.SpraNetSalePriceRealisedComponent != undefined && !this.SpraNetSalePriceRealisedComponent.Validation()) {
      return false;
    } else if (this.SpraCompetitionDetailComponent != undefined && !this.SpraCompetitionDetailComponent.Validation()) {
      return false;
    } else if (this.MultipleFileUploadComponent != undefined && !this.MultipleFileUploadComponent.Validation()) {
      return false;
    } else if (this.SpraPriceJustificationComponent != undefined && !this.SpraPriceJustificationComponent.Validation()) {
      return false;
    } else if (this.SpraApprovalRemarksComponent != undefined && !this.SpraApprovalRemarksComponent.Validation()) {
      return false;
    } else {
      return true;
    }

  }


  Validation(): boolean {
    if (!this.utility.CheckNumberRequired(this.SpraRequestDetail.Period)) {
      this._NotificationService.showError("Please enter SPRA period.", "SPRA Validity");
      return false
    }
    else {
      return true;
    }
  }



  GetSpraRequestData() {
    this._TransactionService.GetAllSPRARequestById(this.SPRAId).subscribe((d: any) => {

      this.SPRADetail = JSON.parse(d);
      this.BindSpraDetail();

    }, (error) => {                              //Error callback
      this.utility.Error(error);
    });

  }

  BindSpraDetail() {
    this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId = this.SPRADetail.ProdSegmentId;
    this.opsPartSerachComponent.ProductSearchParam.AdvanceGroupId = this.SPRADetail.AdvanceGroupId;
    // TKT:56918 
    this.opsPartSerachComponent.AdvanceGroupId = this.SPRADetail.AdvanceGroupId.toString();
    this.opsPartSerachComponent.GradeId = this.SPRADetail.GradeId; //Added by rahul yadav on 12/7/2021
    this.SpraRequestDetail.SaleType = this.SPRADetail.SaleType;
    this.SpraRequestDetail.Period = this.SPRADetail.Period;
    this.OnPeriodChange();
    this.SpraCompetitionDetailComponent.Mode = this.Mode;
    this.SpraApprovalComponent.Mode = this.Mode;
    this.SpraCompetitionDetailComponent.SPRACompetitionDetailArray = this.SPRADetail.ComptDetail;
    this.SpraCompetitionDetailComponent.SPRACompetitionDetailArray.push(new SPRACompetitionDetailParams()); // to add new row

    if (this.SPRADetail.Consignee != undefined) {
      this.opsPartSerachComponent.spraConsigneeData = this.SPRADetail.Consignee;
      //added by rahul yadav on 11/05/2022
      this.opsPartSerachComponent.ReviewedSpra = this.SPRADetail.ReviewedSpra;

    }




    this.MultipleFileUploadComponent.mode = this.Mode;

    this.MultipleFileUploadComponent.UploadFileData = new Array<UploadFileData>();
    let uploadFileData: UploadFileData = new UploadFileData();
    if (this.SPRADetail.Documents != undefined && this.SPRADetail.Documents.length > 0) {
      Promise.all(this.SPRADetail.Documents.map((element: any, index: number) => {
        uploadFileData = new UploadFileData()
        uploadFileData.Purpose = element.purpose;
        uploadFileData.IsNewRow = true;
        let file: File = new File([" "], element.purpose);
        uploadFileData.File = file;
        uploadFileData.disable = true;
        uploadFileData.DownloadFilePath = element.fileName;
        this.MultipleFileUploadComponent.UploadFileData.push(uploadFileData)
        if (index == this.SPRADetail.Documents.length - 1) {
          this.MultipleFileUploadComponent.addRow(uploadFileData, index);
        }
      }));
    } else {
      uploadFileData = new UploadFileData();
      this.MultipleFileUploadComponent.addRow(uploadFileData, 0);
    }




    if (this.SpraNetSalePriceRealisedComponent != undefined) {
      this.SpraNetSalePriceRealisedComponent.SaleType = this.SpraRequestDetail.SaleType;
    }
    if (this.SpraApprovalComponent != undefined) {
      this.SpraApprovalComponent.SaleType = this.SpraRequestDetail.SaleType;
      this.opsPartSerachComponent.SaleType = this.SpraRequestDetail.SaleType;

    }

    this.opsPartSerachComponent.productArray = new Array<OpsProduct>();
    this.opsPartSerachComponent.Mode = this.Mode;
    Promise.all(this.SPRADetail.ProdDetail.map((element: any, index: number) => {
      let opsProduct: OpsProduct = new OpsProduct()
      this.opsPartSerachComponent.ProductSearchParam.ProductCode = element.ProductCode.replace(/\s+$/g, '');
      this.opsPartSerachComponent.ProductSearchParam.ProductId = element.ProductId;
      opsProduct.Price = element.UnitPrice;
      opsProduct.Quantity = element.Quantity;
      opsProduct.PriceList = element.PriceList;
      opsProduct.WorkSheetLanded = element.WorkSheetLanded;
      opsProduct.WorkSheetNSP = element.WorkSheetNSP;
      opsProduct.BookingLanded = element.BookingLanded;
      opsProduct.UnitWSCost = element.UnitWSCost;
      opsProduct.IsNewRow = true;
      opsProduct.PId = element.ProductId;
      opsProduct.gID = element.Grade;
      opsProduct.pQty = element.Quantity;
      this.opsPartSerachComponent.productArray.push(opsProduct);
      this.opsPartSerachComponent.BindProductAutocomplete(opsProduct, index, true);





      if (index == this.SPRADetail.ProdDetail.length - 1) {
        this.opsPartSerachComponent.addRow(opsProduct);
        this.SpraApprovalComponent.BindWarrenty(this.SPRADetail.ProdSegmentId, this.SpraRequestDetail.SaleType, this.SPRADetail.PriceApproval.WarrantyMonth);
        this.BindOtherComponentDetailAfterProduct();

        // this.opsPartSerachComponent.ProductSearchParam.WarrantyMonth = element.warrantyMonth;
        // this.ChangeOpsPartSerach(this.opsPartSerachComponent.ProductSearchParam);
      }



    }));
  }

  BindOtherComponentDetailAfterProduct() {
    setTimeout(() => {

      setTimeout(() => {
        if (this.SPRADetail.Amcv != undefined) {
          // this.SpraAmcvRentalComponent.SpraRentalAmcvModel.MachineLife = this.SPRADetail.Amcv.MachineLife;
          this.SpraAmcvRentalComponent.SpraRentalAmcvModel = this.SPRADetail.Amcv;
          this.spraRentalPL.IsNotionalRent = this.SPRADetail.Amcv.NotionalRent; //Added by rahul yadav on 28/6/2021 in case of notional rent
          if (this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail.length > 0) {
            this.SpraApprovalComponent.IsSpraHaveCopMfd = this.opsPartSerachComponent.GetSpraHaveCopMfdTag();
          }
        }
        this.SpraAmcvRentalComponent.MachineLife = this.SPRADetail.Amcv.MachineLife;
        this.opsPartSerachComponent.GetFinishedGoodsTotalPrice();
        this.SpraApprovalComponent.SpraApprovalParams = this.SPRADetail.PriceApproval;
        this.SpraAmcvRentalComponent.SpraApprovalParams = this.SPRADetail.PriceApproval;
      }, 1000);



      // ADDED BY RAJAN SINGH ON 22 APR 2021 -->> TO SHOW SPRA NO AS PRICE REF --
      if (this.RefSpraDetail != undefined && this.RefSpraDetail.SpraId != undefined) {
        this.SpraApprovalComponent.SpraApprovalParams.PriceRef = this.RefSpraDetail.RequestNo;
      }
      //Added By rahul yadav on 28/05/2021 in case of priceref
      if (this.SPRADetail.SPRAPriceRefId != undefined) {
        this.SPRAPriceRefId = JSON.parse(this.SPRADetail.SPRAPriceRefId);

        this.SpraApprovalComponent.SPRAPriceRef.SPRAId = this.SPRAPriceRefId.PriceRefId;
        this.SpraApprovalComponent.SPRAPriceRef.OfficeId = this.SPRAPriceRefId.OfficeID;
        this.SpraApprovalComponent.SPRAPriceRef.CompanyId = this.SPRAPriceRefId.CompanyID;
        this.SpraApprovalComponent.SPRAPriceRef.Salecode = this.SPRAPriceRefId.SaleCode;
        this.SpraApprovalComponent.SPRAPriceRef.RefId = this.SPRAPriceRefId.RefId;

      }
      // if(this.SPRADetail.CsaRate != undefined){
      //   this.SpraApprovalComponent.SpraCsaRateArray = this.SPRADetail.CsaRate;
      // }

      if (this.SpraApprovalRemarksComponent != undefined) {
        this.SpraApprovalRemarksComponent.SpraApprovalRemarksParams = this.SPRADetail.AppDetail;
        //added by rahul yadav on 06/05/2022 to show review radio button
        this.SpraApprovalRemarksComponent.ShowReviewButton = this.SPRADetail.ShowReviewButton;
        this.SpraApprovalRemarksComponent.IsFromApprovedlist = this.IsFromApprovedlist;
        if(this.SPRADetail.ParentSpraDetails!=undefined){
          this.SpraApprovalRemarksComponent.ParentSpraDetails = this.SPRADetail.ParentSpraDetails;
        }
      }
      //added by rahul yadav on 10/05/2022 for reviewed request
      if (this.SPRADetail.IsReviewRequest != undefined) {
        this.IsRequestReviewed = this.SPRADetail.IsReviewRequest;
        if(this.IsFromApprovedlist){
          this.IsRequestReviewed = true;
          this.opsPartSerachComponent.ReviewedSpra = true;
          this.MultipleFileUploadComponent.IsFromApprovedlist = true;
        }
      }
    //  this.SPRADetail.ProfitTag = "Y";  // for testing only

      // this.Mode == 'I' // ADDED BY RAJAN SINGH ON 22 APRIL 2021 -- TO HANDLE COPY SPRA FUNCTIONALITY
      if (this.SPRADetail.ProfitTag == "N" || this.Mode == 'I') {
        this.ProfitTag = false;
      } else {
        this.ProfitTag = true;
      }
      this.opsPartSerachComponent.ProfitTag = this.ProfitTag;
      this.SpraApprovalComponent.ProfitTag = this.ProfitTag;
      if (this.SpraAmcvRentalComponent != undefined) {
        this.SpraAmcvRentalComponent.SaleType = this.SpraRequestDetail.SaleType;
        this.SpraAmcvRentalComponent.ProfitTag = this.ProfitTag;
      }
    //commented by rahul yadav on 14/07/2022
      // let ArrDistance: Array<number>;
      // ArrDistance = [];
      // this.SPRADetail.DistanceID.forEach((element: any) => {
      //   //ArrDistance.push(element.DistanceID);
      //   //element.Qty added by rahul yadav to get qty based on distance
      //   ArrDistance.push(element.DistanceID, element.Qty);

      // });

      

      // this.SpraAmcvRentalComponent.DistanceID = ArrDistance;
      //added by rahul yadav on 14/07/2022 for distanceid
     // this.SpraAmcvRentalComponent.DistanceID = JSON.parse(this.SPRADetail.DistanceID);
      // debugger


      if(this.opsPartSerachComponent.spraConsigneeData!=undefined){
        
        // this._TransactionService.GetConsigneeDistanceId(JSON.stringify(this.opsPartSerachComponent.spraConsigneeData)).subscribe((d: any) => {
          console.log(this.opsPartSerachComponent.spraConsigneeData);
        this._TransactionService.GetConsigneeDistanceId(JSON.stringify(this.SummarizeConsigneeData(this.opsPartSerachComponent.spraConsigneeData))).subscribe((d: any) => {
         if(d){
          // console.log(d);
          this.SpraAmcvRentalComponent.DistanceID = JSON.parse(d);
         }
        });
      }

      
      if (this.SpraNetSalePriceRealisedComponent != undefined) {
        this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams = this.SPRADetail.NetSalePriceRealised;
        this.SpraNetSalePriceRealisedComponent.DealerParam.OfficeId = this.SpraRequestDetail.OfficeId;
        this.SpraNetSalePriceRealisedComponent.BindDealerList(this.SPRADetail.NetSalePriceRealised.PartnerId);
      }
     //added by swati on 19/05/2021 to calculate total discount
     this.CalculateTotDiscount();
    
      // this.GetExistingCsaRate();
    });

    setTimeout(() => {
      if (this.opsPartSerachComponent.ProfitTag == true) {
        this.SetEmiBaseDetails();
        this.opsPartSerachComponent.ProductProfitablity.TotLoanAmount = this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.LoanAmount;

        this.opsPartSerachComponent.CalculateTotalValue();
        this.BindDiscountView();
      }
    }, 500);

    //added by swati on 19/05/2021 to calculate profit percentage
    setTimeout(() => {      
      this.SpraAmcvRentalComponent.CalculateTotalSaleValue(); 
       //Added by rahul yadav on 30/05/2021 for consigneeDetails
       if (this.SpraViewConsigneeComponent != undefined && this.SPRADetail.ConsigneeDetails != undefined) {
          this.SpraViewConsigneeComponent.ConsineeDetails = this.SPRADetail.ConsigneeDetails;
        }
      this.GetPLProfitPerc();
      // this.utility.GetRentalPLPercentage(this.spraRentalPL,this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail)
      this.calculatePL();
      this.opsPartSerachComponent.ProductProfitablity.ProfitBeforeTax = this.spraRentalPL.SumProfitWithoutIntPerc;
      this.opsPartSerachComponent.ProductProfitablity.ProfitBeforeTaxWithInt = this.spraRentalPL.SumProfitWithIntPerc;
    }, 6000);

  }

calculatePL(){
  // debugger
  this.spraRentalPL.InterestPL = this.spraRentalPL.InterestCostForPL;   
    this.SpraRentalPLCalculation.spraRentalPL =  this.spraRentalPL;
    this.SpraRentalPLCalculation.ConvertMachineLifeToYears();
    this.SpraRentalPLCalculation.CalculateRevenue(this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail);
}

CalculateTotDiscount()
{
  this.opsPartSerachComponent.ProductProfitablity.TotDiscount=0;
  if(this.SPRADetail != undefined){
  if(this.SPRADetail.NetSalePriceRealised.FreeItem!=undefined)
  {
    this.opsPartSerachComponent.ProductProfitablity.TotDiscount= this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SPRADetail.NetSalePriceRealised.FreeItem);
  }
  if(this.SPRADetail.NetSalePriceRealised.AgentCommission!=undefined)
  {
    this.opsPartSerachComponent.ProductProfitablity.TotDiscount= this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SPRADetail.NetSalePriceRealised.AgentCommission);
  }
  if(this.SPRADetail.NetSalePriceRealised.InstallationCommission!=undefined)
  {
    this.opsPartSerachComponent.ProductProfitablity.TotDiscount= this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SPRADetail.NetSalePriceRealised.InstallationCommission);
  }
  if(this.SPRADetail.NetSalePriceRealised.OtherDiscount!=undefined)
  {
    this.opsPartSerachComponent.ProductProfitablity.TotDiscount= this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SPRADetail.NetSalePriceRealised.OtherDiscount);
  }
  if(this.SPRADetail.NetSalePriceRealised.DealerCommission!=undefined)
  {
    this.opsPartSerachComponent.ProductProfitablity.TotDiscount= this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SPRADetail.NetSalePriceRealised.DealerCommission);
  }
  }
}

  OnPeriodChange() {
    // Sales Admin Onwards  
    // if(this.ProfitTag){
    if (this.utility.CheckNumberRequired(this.SpraRequestDetail.Period)) {
      this.ValidTill = this.utility.AddDays(new Date(), this.SpraRequestDetail.Period);
      this.SpraRequestDetail.ValidTill = this.utility.AddDays(new Date(), this.SpraRequestDetail.Period, "ForApi");
    }
    // }  
  }


  GetExistingCsaRate() {
    this._MasterService.GetExistingCsaRate(this.SpraRequestDetail.RefId).subscribe((d: any) => {
      if (d && d != "") {
        this.ExistingCsaRate = JSON.parse(d);
        Promise.all(this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail.map(e => {
          let ExistingCsaRate: any[] = this.ExistingCsaRate.filter(ec => e.CounterId == ec.CounterId)
          if (ExistingCsaRate != undefined && ExistingCsaRate.length > 0) {
            e.ExistingCSARate = ExistingCsaRate[0].Rate;
          }
        }));
      }
    });

  }



  // PriceRefSelected(RefSpraDetail:any){
  //   if (RefSpraDetail != undefined && RefSpraDetail.SpraId != undefined){
  //     this.SPRAId = RefSpraDetail.SpraId
  //     this.RefSpraDetail= RefSpraDetail;
  //     this.GetSpraRequestData();
  //     this.SpraApprovalComponent.SpraApprovalParams.PriceRef = RefSpraDetail.RequestNo;
  //   }
  // }

  BindSpraEnquiryDetail() {
    if (this.SpraRequestDetail.OpportunityId != undefined) {
      this._TransactionService.GetSpraEnquireyDetailById(this.SpraRequestDetail.OpportunityId).subscribe((d: any) => {
        this.SPRADetail = JSON.parse(d);
        this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId = this.SPRADetail.ProdSegmentId;
        this.opsPartSerachComponent.ProductSearchParam.AdvanceGroupId = this.SPRADetail.AdvanceGroupId;
        this.SpraCompetitionDetailComponent.Mode = this.Mode;
        this.SpraApprovalComponent.Mode = this.Mode;
        this.opsPartSerachComponent.productArray = new Array<OpsProduct>();
        this.opsPartSerachComponent.Mode = this.Mode;
        Promise.all(this.SPRADetail.ProdDetail.map((element: any, index: number) => {
          let opsProduct: OpsProduct = new OpsProduct()
          this.opsPartSerachComponent.ProductSearchParam.ProductCode = element.ProductCode.replace(/\s+$/g, '');
          this.opsPartSerachComponent.ProductSearchParam.ProductId = element.ProductId;
          opsProduct.Price = element.UnitPrice;
          opsProduct.Quantity = element.Quantity;
          opsProduct.IsNewRow = true;
          this.opsPartSerachComponent.productArray.push(opsProduct);
          this.opsPartSerachComponent.BindProductAutocomplete(opsProduct, index, true);
          if (index == this.SPRADetail.ProdDetail.length - 1) {
            this.opsPartSerachComponent.addRow(opsProduct);
            this.SpraApprovalComponent.BindWarrenty(this.SPRADetail.ProdSegmentId, this.SpraRequestDetail.SaleType, 0);
          }
             //added by rahul yadav on 24/06/2021 amcv component not showing
             setTimeout(() => {
              this.ChangeOpsPartSerach(this.opsPartSerachComponent.ProductSearchParam);
             },1000);

        }));
      
      }, (error) => {                              //Error callback
        this.utility.Error(error);
      });
    }

  }





  UploadDocuments(): void {

    let UploadFileName: any[] = [];
    if (this.MultipleFileUploadComponent.UploadFileData != undefined) {

      // Filtering Upload file aaray for which file needs to be upload
      let dtUploadedFiles: UploadFileData[] = this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.File != undefined && ft.disable == false });

      // If PAGE IS IN VALIDATION MODE -->> FILTERING ALREDAY UPLOADED FILE DATA
      Promise.all(this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.DownloadFilePath != "" }).map((t, index) => {
        UploadFileName.push({ "fileName": t.DownloadFilePath, "purpose": t.Purpose });
      }));


      if (dtUploadedFiles.length > 0) {
        for (let i = 0; i < dtUploadedFiles.length; i++) {
          let uploadFileData: UploadFileData = dtUploadedFiles[i];
          if (uploadFileData.File != undefined) {
            let progressInfoObj = { "value": 0, "fileName": uploadFileData.File.name };
            this.MultipleFileUploadComponent.progressInfos.push(progressInfoObj);
            this.uploadService.upload(uploadFileData).subscribe(
              event => {
                if (event) {
                  let dt: any = event;
                  if (dt.body != undefined) {
                    UploadFileName.push({ "fileName": dt.body.fileName, "purpose": dt.body.purpose });
                    // ON LAST FILE UPLOAD -- ASSGINIG DOCUMENTS JSON TO SPRA REQUEST OBJECT -->> AND CALLING SPRA CREATION METHOD          
                    if (i == dtUploadedFiles.length - 1) {
                      this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
                      this.InsertUploadSpra();
                    }
                  }
                  if (event.type === HttpEventType.UploadProgress && event.total != undefined) {
                    this.MultipleFileUploadComponent.progressInfos[i].value = Math.round(100 * event.loaded / event.total);
                  }
                }

              },
              err => {
                this.MultipleFileUploadComponent.progressInfos[i].value = 0;
                throw new Error('Unable to upload document.');
              });

          }

        }


      } else {
        this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
        this.InsertUploadSpra();
      }

    }
  }

  OpenEmiDetail(): void {

    this.SetEmiBaseDetails();
    const dialogRef = this.dialog.open(SpraRentalEmiComponent, {
      width: '100%',
      data: { spraRentalEmiModel: this.spraRentalEmiModel }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data != undefined) {
      }
    });
  }



  OpenPLDetail(): void {
    this.GetPLProfitPerc();

    const dialogRef = this.dialog.open(SpraRentalPLComponent, {
      width: '100%',
      // height: '100vh',
      data: { spraRentalPL: this.spraRentalPL, CounterDetail: this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data != undefined) {
      }
    });
  }


  GetPLProfitPerc() {

    this.GetInterestCostForPL();
    this.spraRentalPL.InterestCostForPL = this.InterestCostForPL;
    this.spraRentalPL.PLMachineLife = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.LockInMonths;
    // this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail.forEach((cd) => {
    //   if (cd.CounterId == 1) {
    //     this.spraRentalPL.CustCommitCopyPerMonthBW = cd.CustomerCommitmentCopy;
    //     this.spraRentalPL.EstMinimumCopyPerMonthBW = cd.EMCL;
    //     this.spraRentalPL.AgreedCSARateBW = cd.AgreedCSARate;
    //     this.spraRentalPL.AgreedFreeCopyBW = cd.AgreedFreeCopy;
    //     // this.spraRentalPL.CSACostRateBW = cd.StdCSARate;
    //     this.spraRentalPL.CSACostRateBW = cd.CSACostRate;
    //   } else if (cd.CounterId == 2) {
    //     this.spraRentalPL.CustCommitCopyPerMonthColor = cd.CustomerCommitmentCopy;
    //     this.spraRentalPL.EstMinimumCopyPerMonthColor = cd.EMCL;
    //     this.spraRentalPL.AgreedCSARateColor = cd.AgreedCSARate;
    //     this.spraRentalPL.AgreedFreeCopyColor = cd.AgreedFreeCopy;
    //     // this.spraRentalPL.CSACostRateColor = cd.StdCSARate;
    //     this.spraRentalPL.CSACostRateColor = cd.CSACostRate;
    //   }
    //   else if (cd.CounterId == 3) {
    //     this.spraRentalPL.CustCommitCopyPerMonthBWA3 = cd.CustomerCommitmentCopy;
    //     this.spraRentalPL.EstMinimumCopyPerMonthBWA3 = cd.EMCL;
    //     this.spraRentalPL.AgreedCSARateBWA3 = cd.AgreedCSARate;
    //     this.spraRentalPL.AgreedFreeCopyBWA3 = cd.AgreedFreeCopy;
    //     // this.spraRentalPL.CSACostRateBWA3 = cd.StdCSARate;
    //     this.spraRentalPL.CSACostRateBWA3 = cd.CSACostRate;
    //   }
    //   else if (cd.CounterId == 4) {
    //     this.spraRentalPL.CustCommitCopyPerMonthColorA3 = cd.CustomerCommitmentCopy;
    //     this.spraRentalPL.EstMinimumCopyPerMonthColorA3 = cd.EMCL;
    //     this.spraRentalPL.AgreedCSARateColorA3 = cd.AgreedCSARate;
    //     this.spraRentalPL.AgreedFreeCopyColorA3 = cd.AgreedFreeCopy;
    //     // this.spraRentalPL.CSACostRateColorA3 = cd.StdCSARate;
    //     this.spraRentalPL.CSACostRateColorA3 = cd.CSACostRate;
    //   }

    // });
    this.spraRentalPL.PLLockInMonth = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.LockInMonths;
    this.spraRentalPL.ResidualValue = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.ResidualValue;
    this.spraRentalPL.MonthlyRent = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.MonthlyRent;
    this.SetEmiBaseDetails();
    this.spraRentalPL.TotalCostAmount = this.opsPartSerachComponent.ProductProfitablity.TotCostAmount;


  }

  GetInterestCostForPL() {
    this.SetEmiBaseDetails();
    this.InterestCostForPL = [];
    let InterestCost: number = 0;
    this.utility.CreateEmiChart(this.spraRentalEmiModel.EmiDetailWithFreeCopy);
    Promise.all(this.spraRentalEmiModel.EmiDetailWithFreeCopy.SpraEmiChart.map((item, i) => {
      InterestCost += item.Interest;
      if ((i + 1) % 12 == 0 || (i + 1) == this.spraRentalEmiModel.EmiDetailWithFreeCopy.SpraEmiChart.length) {
        this.InterestCostForPL.push(InterestCost);
        InterestCost = 0;
      }
    }));
  }

  SetEmiBaseDetails() {
    this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.TotalRentalAmount = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.LockInMonths * this.SpraAmcvRentalComponent.SpraRentalAmcvModel.MonthlyRent;
    this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.LockInMonths = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.LockInMonths;
    this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.EMI = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.MonthlyRent - this.SpraAmcvRentalComponent.SpraRentalAmcvModel.FreeCopyValue;
    this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.RateOfInterest = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.RateOfInterest;
    this.utility.CalculateLoanAmount(this.spraRentalEmiModel.EmiDetailWithOutFreeCopy);

    this.spraRentalEmiModel.EmiDetailWithFreeCopy.TotalRentalAmount = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.LockInMonths * this.SpraAmcvRentalComponent.SpraRentalAmcvModel.MonthlyRent;
    this.spraRentalEmiModel.EmiDetailWithFreeCopy.LockInMonths = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.LockInMonths;
    this.spraRentalEmiModel.EmiDetailWithFreeCopy.EMI = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.MonthlyRent;
    this.spraRentalEmiModel.EmiDetailWithFreeCopy.RateOfInterest = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.RateOfInterest;
    this.spraRentalEmiModel.EmiDetailWithFreeCopy.FreeCopyValue = this.SpraAmcvRentalComponent.SpraRentalAmcvModel.FreeCopyValue;
    this.utility.CalculateLoanAmount(this.spraRentalEmiModel.EmiDetailWithFreeCopy);
  }


  SpraHaveFinishGood(IsSpraHaveFinishGood: boolean) {
    this.IsSpraHaveFinishGood = IsSpraHaveFinishGood;
    this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
    this.SpraApprovalComponent.IsSpraHaveCopMfd = this.opsPartSerachComponent.GetSpraHaveCopMfdTag();

  }

  
  Consignee(Consignee: any) {
    // debugger
    // this._TransactionService.GetConsigneeDistanceId(JSON.stringify(this.opsPartSerachComponent.spraConsigneeData)).subscribe((d: any) => {
      this._TransactionService.GetConsigneeDistanceId(JSON.stringify(this.SummarizeConsigneeData(this.opsPartSerachComponent.spraConsigneeData))).subscribe((d: any) => {
      if(d){
       this.SpraAmcvRentalComponent.DistanceID = JSON.parse(d);
      }

     });

  }

  // RecalculatePLDetail() {
  //   this.SetEmiBaseDetails();
  //   this.opsPartSerachComponent.TotLoanAmount = this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.LoanAmount;
  //   if (this.opsPartSerachComponent.ProfitTag == true) {
  //     this.opsPartSerachComponent.CalculateTotalValue();
  //   }
  //   this.BindDiscountView();
  //   this.GetPLProfitPerc();
  //   this.utility.GetRentalPLPercentage(this.spraRentalPL)
  //   this.opsPartSerachComponent.ProfitBeforeTax = this.spraRentalPL.SumProfitWithoutIntPerc;
  //   this.opsPartSerachComponent.ProfitBeforeTaxWithInt = this.spraRentalPL.SumProfitWithIntPerc;

  // }


  BindDiscountView() {
    if (this.SpraDiscountViewComponent != undefined) {
      let _DiscountView: DiscountView = new DiscountView();
      if (this.SpraNetSalePriceRealisedComponent != undefined) {
        _DiscountView.DealerComm = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.DealerCommission + this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.AgentCommission;
        _DiscountView.InstallComm = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.InstallationCommission;
        _DiscountView.FreeItem = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.FreeItem;
        _DiscountView.Other = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.OtherDiscount;
        _DiscountView.IsRental = true;
      }
      _DiscountView.TotalPurOrderVal = this.opsPartSerachComponent.ProductProfitablity.TotLoanAmount;
      _DiscountView.NetSalePriceRealised = (_DiscountView.TotalPurOrderVal - _DiscountView.DealerComm - _DiscountView.InstallComm - _DiscountView.FreeItem - _DiscountView.Other);

      this.SpraDiscountViewComponent.SpraDiscountView = _DiscountView;

    }

  }


  RecalculatePLDetail(event:any=null) {
    this.SpraAmcvRentalComponent.CalculateRentFromNotionalRent();
    this.CalculateTotDiscount();
    this.SetEmiBaseDetails();
    this.opsPartSerachComponent.ProductProfitablity.TotLoanAmount = this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.LoanAmount;
    if (this.opsPartSerachComponent.ProfitTag == true) {      
      this.opsPartSerachComponent.CalculateTotalValue();
    }
    this.BindDiscountView();

    
   setTimeout(() => {
      // When this function is callinf from "CalculateSrvRevenue" function of AMCV rental page  -->> not execute CalculateTotalSaleValue -- to stop circular Calling 
      // debugger
      if(event == undefined || event.data != 'FromAMCV'){
        this.SpraAmcvRentalComponent.CalculateTotalSaleValue();
      }
      this.GetPLProfitPerc();
      this.calculatePL();
      // this.utility.GetRentalPLPercentage(this.spraRentalPL,this.SpraAmcvRentalComponent.SpraRentalAmcvModel.CounterDetail);
      this.opsPartSerachComponent.ProductProfitablity.ProfitBeforeTax = this.spraRentalPL.SumProfitWithoutIntPerc;
      this.opsPartSerachComponent.ProductProfitablity.ProfitBeforeTaxWithInt = this.spraRentalPL.SumProfitWithIntPerc;
     }, 500);

  }

  CheckOpsForSpraId(SPRAId :Number):Boolean{
    let IsValid =false;
 this._TransactionService.CheckOpsForSPRA(this.SPRAId).subscribe((d): any => {
  //  debugger
   if (d==false) {
    // let Message: string = "SPRA Request [" + d + "] generated successfully."
    //  console.log(d);
     IsValid = false
   } else {
     IsValid = true;
   }
 }, (error) => {
   this.utility.Error(error);
   this._NotificationService.showError();
   throw new Error('SPRA request not generated.');
 });
 return IsValid;
}
   //below code added by rahul yadav on 09/05/2022 for reviewed Spra
   InitializeSpraRequestReviewModal(){
    try{
 
     
      this.DisableSubmit = true;
      this.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
      this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
      this.SpraApprovalComponent.ProdSegment = this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId;
      if (this.ValidateSpra()) {
        this.SpraRequestDetail.ProdSegmentId = this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId;
        this.SpraRequestDetail.AdvanceGroupId = parseInt(this.opsPartSerachComponent.AdvanceGroupId);
  
        this.SpraRequestDetail.EnteredBy = this.utility.user.employeeId;
        let _ProductDetails = new Array<OpsProductDetail>();
        Promise.all(this.opsPartSerachComponent.productArray.map(element => {
          if (element.SelectedProduct != undefined) {
            let _OpsProductDetail: OpsProductDetail = new OpsProductDetail();
            _OpsProductDetail.ProductId = element.SelectedProduct.productId;
            _OpsProductDetail.ProdMakeId = element.SelectedProduct.prodMakeId;
            _OpsProductDetail.ProdSegmentId = element.SelectedProduct.prodSegmentId;
            _OpsProductDetail.ProductGroupId = element.SelectedProduct.productGroupId;
            _OpsProductDetail.HsnCode = element.SelectedProduct.hsncode;
            _OpsProductDetail.GradeId = element.SelectedProduct.gradeId;
            _OpsProductDetail.UnitPrice = element.Price;
            _OpsProductDetail.Quantity = element.Quantity;          
            _OpsProductDetail.UnitSalePrice = element.UnitSalePrice;
            _OpsProductDetail.SaleAmount = element.SaleAmount;
            _OpsProductDetail.UnitWSCost = element.UnitWSCost;          
            _ProductDetails.push(_OpsProductDetail);
          }
        }));
        this.SpraRequestDetail.ProductDetails = JSON.stringify(_ProductDetails);
        if (this.ProfitTag){
          this.RecalculatePLDetail();
          let _PriceRefCalculations:PriceRefCalculations = new PriceRefCalculations();
          _PriceRefCalculations.Product = this.opsPartSerachComponent.ProductProfitablity;        
          _PriceRefCalculations.Product.NetSaleValueVGP = (((_PriceRefCalculations.Product.TotLoanAmount - _PriceRefCalculations.Product.TotDiscount) -_PriceRefCalculations.Product.TotCostAmount)/(_PriceRefCalculations.Product.TotLoanAmount - _PriceRefCalculations.Product.TotDiscount))*100;
          _PriceRefCalculations.EMI = this.spraRentalEmiModel;
          _PriceRefCalculations.PL = this.spraRentalPL;
          // if(this.SpraAmcvComponent != undefined){
          //   _PriceRefCalculations.AMCV = this.SpraAmcvComponent.AMCVProfitablity;
          // }
          this.SpraRequestDetail.PriceRefCalculations  = JSON.stringify(_PriceRefCalculations);
        }
  
  
        if (this.opsPartSerachComponent.spraConsigneeData.length > 0) {
          this.SpraRequestDetail.Consignee = JSON.stringify(this.opsPartSerachComponent.spraConsigneeData);
        }
        this.SpraRequestDetail.OpsId = this.LinkedOps.OpsId;
        this.SpraRequestDetail.OfficeId = this.utility.user.officeId;
  
        this.SpraRequestDetail.PriceApproval = JSON.stringify(this.SpraApprovalComponent.SpraApprovalParams);
  
        if (this.SpraNetSalePriceRealisedComponent != undefined) {
          this.SpraRequestDetail.NetSalePriceRealised = JSON.stringify(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams);
        }
        this.SpraRequestDetail.ComptDetail = JSON.stringify(this.SpraCompetitionDetailComponent.SPRACompetitionDetailArray.filter((t) => { return (t.CompName != undefined && t.CompName != "") }));
  
        if (this.SpraAmcvRentalComponent != undefined) {
          this.SpraRequestDetail.Amcv = JSON.stringify(this.SpraAmcvRentalComponent.SpraRentalAmcvModel)
        }
  
        if (this.Mode != "U") {
          if (this.SpraPriceJustificationComponent.SpraPriceJustificationParams.BoRemarks != undefined) {
            this.SpraRequestDetail.Remarks = this.SpraPriceJustificationComponent.SpraPriceJustificationParams.BoRemarks;
          }
        }
  
        if (this.SpraApprovalComponent != undefined && this.SpraApprovalComponent.SpraCsaRateArray.length > 0) {
          this.SpraRequestDetail.CsaRate = JSON.stringify(this.SpraApprovalComponent.SpraCsaRateArray);
        }
  
        //  first uploading document -->> after upload document -->> InsertUploadSpra() will call to create SPRA
        this.UploadReviewDocuments();
      }
      else{
        this.DisableSubmit = false;  
      }
    } catch(Error:any) {
      this.DisableSubmit  = false;
      // console.log(Error.message);
    }finally{
      return true;
    }
  }
  UploadReviewDocuments(): void {
    let UploadFileName: any[] = [];
    if (this.MultipleFileUploadComponent.UploadFileData != undefined) {

      // Filtering Upload file aaray for which file needs to be upload
     // let dtUploadedFiles: UploadFileData[] = this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.File != undefined && ft.disable == false });
      let dtUploadedFiles: UploadFileData[] = this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.File != undefined});
      // If PAGE IS IN VALIDATION MODE -->> FILTERING ALREDAY UPLOADED FILE DATA
      // this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.DownloadFilePath != "" }).forEach((t, index) => {
      //   UploadFileName.push({ "fileName": t.DownloadFilePath, "purpose": t.Purpose });
      // });


      if (dtUploadedFiles.length > 0) {
        for (let i = 0; i < dtUploadedFiles.length; i++) {
          let uploadFileData: UploadFileData = dtUploadedFiles[i];
          if (uploadFileData.File != undefined) {
            let progressInfoObj = { "value": 0, "fileName": uploadFileData.File.name };
            this.MultipleFileUploadComponent.progressInfos.push(progressInfoObj);
            this.uploadService.uploadReview(uploadFileData).subscribe(
              event => {
                setTimeout(() => {
                if (event) {
                  let dt: any = event;
                  if (dt.body != undefined) {
                    UploadFileName.push({ "fileName": dt.body.fileName, "purpose": dt.body.purpose });
                    // ON LAST FILE UPLOAD -- ASSGINIG DOCUMENTS JSON TO SPRA REQUEST OBJECT -->> AND CALLING SPRA CREATION METHOD
                    if (i == dtUploadedFiles.length - 1) {
                      this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
                      this.InsertUploadReviewSpra();
                    }
                  }
                  if (event.type === HttpEventType.UploadProgress && event.total != undefined) {
                    this.MultipleFileUploadComponent.progressInfos[i].value = Math.round(100 * event.loaded / event.total);
                  }
                }
              }, 500);

              },
              err => {                
                this.MultipleFileUploadComponent.progressInfos[i].value = 0;
                throw new Error('Unable to upload document.');
              });

          }

        }


      } else {
        this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
        this.InsertUploadReviewSpra();
      }

    }
  }
  InsertUploadReviewSpra() {
   // if (this.Mode == "U") {
// debugger
      let _SpraValidation: SpraValidation = new SpraValidation();
        //added by rahul yadav on 09/05/2022 for parent spra id
       
      this.SpraRequestDetail.Id = 0;
      this.SpraRequestDetail.ParentSpraId = this.SPRAId;
      this.SpraRequestDetail.RequestNo = this.SPRADetail.RequestNo;
      this.SpraRequestDetail.OfficeId = this.SPRADetail.OfficeID;
      this.SpraRequestDetail.EnteredBy = this.SPRADetail.EnteredById;
      this.SpraRequestDetail.OpportunityId = this.SPRADetail?.OpportunityId;
      this.SpraRequestDetail.Remarks = this.SPRADetail.Remarks;
      //this.SpraRequestDetail.Documents =  this.SpraRequestDetail.Documents;
     // _SpraValidation.SpraRequest.Documents="";
      _SpraValidation.SpraRequest = this.SpraRequestDetail;
      //_SpraValidation.SpraRequest.Documents=Documents;
      
      // this._TransactionService.UpdateSPRAData(this.SpraRequestDetail).subscribe((d):any =>{
      //   if(d){
      let Message: string;
      //  let Message:string = "SPRA ["+ d +"] updated"
      this.spraApprovalDetail.SpraRequestId = this.SPRAId;

      let spraApp: SpraApprovalRemarksParams;
      spraApp = this.SpraApprovalRemarksComponent.SpraApprovalRemarksParams.filter((item) => {
        return item.Tag == 0
      }
      )[0];

      if (spraApp.Remarks != undefined) {
        this.spraApprovalDetail.ValidateRemarks = spraApp.Remarks;
      }
      if (spraApp.AppStatus != undefined) {

        this.spraApprovalDetail.ApprovalStatus = spraApp.AppStatus;
      }
      this.spraApprovalDetail.ValidateBy = this.utility.user.employeeId;

      if (this.SpraApprovalRemarksComponent.IsSalesAdmin) {
        _SpraValidation.SpraRequest.ValidationRequired = JSON.stringify(this.SpraApprovalRemarksComponent.ValidationLevel
          .filter((vl) => { return vl.EmployeeId != undefined && vl.EmployeeId > 0 }));
      }

      _SpraValidation.SpraRequestApprovalValidation = this.spraApprovalDetail;
      
      let RedirectionPage: string = "spra-salesadminreview-list";
      if(this.IsCeha && !this.IsFromApprovedlist){
        RedirectionPage = "spra-salesadminreview-list/1";
      }
      if(!this.IsCeha && this.IsFromApprovedlist){
        RedirectionPage = "spra-salesadminapprev-list";
      }
      if(this.IsCeha && this.IsFromApprovedlist){
        RedirectionPage = "spra-salesadminapprev-list/1";
      }
      // if(!this.IsSalesAdmin && this.IsCeha  ){
      //   RedirectionPage = "spra-validationlist/1";
      // }
      // if (this.IsSalesAdmin && !this.IsCeha) { 
      //   RedirectionPage = "spra-adminsalesvalidate-list";
      // }else if(this.IsSalesAdmin && this.IsCeha){
      //   RedirectionPage = "spra-adminsalesvalidate-list/1";
      // }
      
      this._TransactionService.InsertSpraReviewRequest(_SpraValidation).subscribe((d): any => {
        if (d) {
          let Message: string = "SPRA Request [" + d + "] generated successfully."
          if(d=="false"){
            Message ="Ops already created for this SPRA!";
           // this._NotificationService.showWarning("Ops already created for this SPRA!","");
            // return false;
          }
          this.router.navigate([RedirectionPage], {
            state: {
              "Message": Message
            }
          });
        } else {
          this._NotificationService.showError();
        }
      }, (error) => {
        this.utility.Error(error);
        this._NotificationService.showError();
        throw new Error('SPRA request not generated.');
      });
    
  }

  //Added by Rahul Kumar on 26/08/2022 [To summarize the data being sent to the API to get Distance wise FG Count]
  SummarizeConsigneeData(spraConsigneeData: SpraConsigneeData[]) : Array<ConsigneeSummary> {
    let _ConsigneeSummary = new Array<ConsigneeSummary>();
    Promise.all(spraConsigneeData.map((am) => {
        let CS = _ConsigneeSummary.filter((cs) => {return cs.DistanceID == am.DistanceID});
        // console.log(CS);

        if(CS.length == 0)
        {
          let _c = new ConsigneeSummary();
          _c.DistanceID = am.DistanceID;
          
            am.ProductDetails.forEach(PD => {
                // console.log("PD");
                let _P = _c.ProductDetails.filter((P) => {return  P.ProductId == PD.ProductId});
                if(_P.length == 0)
                {
                  let _p = new ConsigneeProductSummary();
                  _p.ProductId = PD.ProductId;
                  _p.Quantity = PD.Quantity;
                  _c.ProductDetails.push(_p);
                }
                else{
                  _P[0].Quantity += PD.Quantity;
                }
            });

          _ConsigneeSummary.push(_c)
        }
        else
        {
          am.ProductDetails.forEach(PD => {
            let _P = CS[0].ProductDetails.filter((P) => {return P.ProductId == PD.ProductId});
            if(_P.length == 0)
            {
              let _p = new ConsigneeProductSummary();
              _p.ProductId = PD.ProductId;
              _p.Quantity = PD.Quantity;
              CS[0].ProductDetails.push(_p);
            }
            else{
              _P[0].Quantity += PD.Quantity;
            }
          });
        }
    }));

    return _ConsigneeSummary;
  }

}





